import React, { Suspense } from 'react'
import RxReactionSelector from '../../../../components/shares/rxReactionSelector'
/*global translate*/
const { timeConverter, rxaget, rxChangeSlug, stringToColour, idToColor ,changeColorSVG} = global.rootRequire('classes/ulti')

const { checkAvatarSender, checkIsOwner, checkName, checkNameUser } = global.rootRequire('classes/chat')
const RxImageGallery = global.rootRequire('components/shares/rxImageGallery').default
const RxGroupsList = global.rootRequire('components/shares/rxGroupList').default
const RxInfoUser = global.rootRequire('components/shares/rxNewUserInfo').default
const RxDragAndDrop = global.rootRequire('components/shares/rxDragAndDrop').default
const SearchComponent = global.rootRequire('themes/main/chat/search/index').default
const RxPollItem = global.rootRequire('components/shares/pollComponent/pollMessItem/poll_item').default
const RxPollListOption = global.rootRequire('components/shares/pollComponent/pollListOption/poll_list_option').default

let zget = global.rxu.get
const PinComponent = global.rootRequire('themes/main/chat/pin_modal').default
const MessageItem = global.rootRequire('themes/main/chat/message_item').default
// const PinComponent = React.lazy(() => import("../pin_modal"));
global.isclient && require('./index.css')

export const renderBody = (vm) => <div id='idzchat' className=' zchat'>
  <div className='zchattab_body'>
    {vm.state.displayDragAndDrop && 
      <RxDragAndDrop 
        token={vm.token}
        group_id={vm.state.group_id} 
        handleMessage={vm.handleMessage}
        userid={vm.userid}
        handleDragOut={ e => vm.handleDragOut(e)}
      >    
      </RxDragAndDrop >
    }
    {
      vm.state.flagPollListOption &&
      <RxPollListOption
        closePollPopup={() => vm.setState({ flagPollListOption: false })}
        pollInfo={vm.state.pollInfo}
        token={vm.token}
        group_id={vm.state.group_id}
        userid={vm.userid}
        group={vm.state.group}
        createPollAnswers={(value) => { vm.createPollAnswers(value) }}
        morepollChoose={(value, pollInfo) => { vm.morepollChoose(value, pollInfo) }}
        pinedMess={vm.state.pinedMess}
      />
    }
    <div id='zchat_body' ref={vm.dropRef_Mess}  className={(vm.state.tabmoreNextprop === true) ? 'zchat_body-active' : 'zchat_body'} >
        <div className='zchat_list' id='zchat_list' 
          onScroll={vm.scrollChatBox}>
          {Object.keys(vm.state.messages).map((odate) => {
            let firstMessageIndex = 0
            return <div key={odate}>
              <div className='zchat_row_child'> 
                {timeConverter(odate, 'dateweek')} 
              </div>
              {(vm.state.messages 
                && vm.state.messages[odate] 
                && vm.state.messages[odate]['data']) 
                && vm.state.messages[odate]['data'].map((currentMsg, i, arr) => {
                
                let isShowAvatar5Minute = false
                let isShowUserName5Minute = false
                let previousMsg = i > 0 ? arr[i-1] : null
                if(previousMsg && [5, 6, 7].indexOf(previousMsg.type) === -1 && currentMsg.sender_uin === previousMsg.sender_uin) 
                { 
                  let dateDiff = Math.floor(Math.abs(Number(previousMsg.created_at / 1000000) - Number(currentMsg.created_at / 1000000)))
                  isShowUserName5Minute = (dateDiff >= 300) ? true : false
                }
                
                let nextMsg = i+1 < arr.length ? arr[i+1] : null
                if(nextMsg && [5, 6, 7].indexOf(nextMsg.type) === -1 && currentMsg.sender_uin === nextMsg.sender_uin) 
                {
                  let dateDiff = Math.floor(Math.abs(Number(nextMsg.created_at / 1000000) - Number(currentMsg.created_at / 1000000)))
                  isShowAvatar5Minute = (dateDiff >= 300) ? true : false
                }

                if([5, 6, 7].indexOf(currentMsg.type) !== -1) firstMessageIndex++

                let flagShowAva = ((i+1 < arr.length && (currentMsg.sender_uin !== arr[i+1].sender_uin || [5, 6, 7].indexOf(arr[i+1].type) !== -1)) 
                      || i+1 === arr.length || isShowAvatar5Minute )
                      && !checkIsOwner(currentMsg, vm.userid)

                let classNameRow = ((rxaget(vm.state, 'mess_id', '') !== currentMsg.message_id.toString()) ? 'zmessage_row': 'zmessage_row zchat_row-selected')

                if (currentMsg.type === -1) {
                  classNameRow += ' zmessage_row_unread'
                }

                if (nextMsg && previousMsg && currentMsg.sender_uin !== vm.userid.toString() && nextMsg.sender_uin === vm.userid.toString() && previousMsg.sender_uin !== vm.userid.toString()) {
                  classNameRow += ' add-padding-row'
                } else if (nextMsg && previousMsg && currentMsg.sender_uin === vm.userid.toString() && nextMsg.sender_uin !== vm.userid.toString()) {
                  classNameRow += ' add-padding-row'
                }

                const reactionCount = vm.countActiveReaction(currentMsg)
                let flagPollItem = vm.showPollItem(currentMsg)//false
                // if(currentMsg.type === 17){
                //   let attachments   = JSON.parse(rxaget(currentMsg, 'attachments', ''))
                //   let poll_type = attachments.poll_type
                //   if(poll_type !== 2 && poll_type !== 3 && poll_type !== 4 && currentMsg.status !== 4){
                //     flagPollItem = true
                //   }
                // }
                return (
                  <div key={currentMsg.message_id} >
                    {
                      !flagPollItem &&
                      <div 
                        className={classNameRow} 
                        onMouseDown={(e) => vm.onClickMouseRight(e, currentMsg)} 
                        ref={(ele) => vm.refScroll_chat[currentMsg.message_id] = ele}
                      >   
                        <MessageItem
                          key={currentMsg.message_id}
                          flagShowAva={flagShowAva}
                          currentMsg={currentMsg} 
                          users={vm.users}
                          userid={vm.userid}
                          group_id={vm.state.group_id} 
                          occupants_uins={vm.state.group.occupants_uins} 
                          lastSeenMessObj={vm.state.lastSeenMessObj}  
                          arrTabsDisplay={vm.state.arrTabsDisplay}
                          index={i}
                          arr={arr}
                          firstMessageIndex={firstMessageIndex}
                          isShowUserName5Minute={isShowUserName5Minute}  
                          onClickNameUser={vm.onClickNameUser}    
                          group={vm.state.group} 
                          netaLink={rxaget(vm.props, 'netaLink', {})} 
                          reactions={currentMsg.reactions}
                          onClickEmoji={vm.handleClickEmoji} 
                          currentMessageIdClicked={vm.state.currentMessageIdClicked} 
                          keywords={vm.state.keywords}
                          clickInfoUser={(userid) => vm.clickInfoUser(userid)}
                          lastSeenMess={vm.groupSeenLast[vm.state.group_id]}
                          choosePoll={(pollInfo) => { vm.choosePoll(pollInfo) }}
                        />
                      </div>
                    }
                    {
                      flagPollItem &&
                      <div onMouseDown={(e) => vm.onClickMouseRight(e, currentMsg)}>
                        <RxPollItem currentMsg={currentMsg} token={vm.token} choosePoll={(pollInfo) => { vm.choosePoll(pollInfo) }} />
                      </div>
                    }
                  </div>
                ) 
                
              })}
            </div>
          })}

          {(vm.arrFilesTmp.length > 0) && vm.arrFilesTmp.map((currentMsg, i, arr) => {
            let previousMsg = i > 0 ? arr[i-1] : null

            let nextMsg = i+1 < arr.length ? arr[i+1] : null
            let flagShowAva = false
            let classNameRow = 'zmessage_row'

            if (currentMsg.type === -1) {
              classNameRow += ' zmessage_row_unread'
            }

            if (nextMsg && previousMsg && currentMsg.sender_uin !== vm.userid.toString() && nextMsg.sender_uin === vm.userid.toString() && previousMsg.sender_uin !== vm.userid.toString()) {
              classNameRow += ' add-padding-row'
            } else if (nextMsg && previousMsg && currentMsg.sender_uin === vm.userid.toString() && nextMsg.sender_uin !== vm.userid.toString()) {
              classNameRow += ' add-padding-row'
            }
        
            return (
              <div key={currentMsg.message_id} className={classNameRow} ref={(ele) => vm.refScroll_chat[currentMsg.message_id] = ele} >   
                <MessageItem
                  key={currentMsg.message_id}
                  flagShowAva={flagShowAva}
                  currentMsg={currentMsg} 
                  users={vm.users}
                  userid={vm.userid}
                  group_id={vm.state.group_id} 
                  occupants_uins={vm.state.group.occupants_uins} 
                  lastSeenMessObj={vm.state.lastSeenMessObj}  
                  arrTabsDisplay={vm.state.arrTabsDisplay}
                  index={i}
                  arr={arr}
                  firstMessageIndex={0}
                  isShowUserName5Minute={false}  
                  onClickNameUser={vm.onClickNameUser}    
                  group={vm.state.group} 
                  netaLink={rxaget(vm.props, 'netaLink', {})} 
                  reactions={currentMsg.reactions}
                  onClickEmoji={vm.handleClickEmoji} 
                  currentMessageIdClicked={vm.state.currentMessageIdClicked} 
                  keywords={vm.state.keywords}
                  clickInfoUser={(userid) => vm.clickInfoUser(userid)}
                  lastSeenMess={vm.groupSeenLast[vm.state.group_id]}
                  choosePoll={(pollInfo) => { vm.choosePoll(pollInfo) }}
                />
              </div>
            )
          })}
        </div>
    </div>
    <div id='menu-message'> 
    {
      [17].indexOf(rxaget(vm.state, 'mess_selected.type', '')) === -1 &&
      <div className='reaction_main-place'>
        <RxReactionSelector 
          onClick={emoji => vm.chooseEmoji(emoji)} 
        />
      </div>
    }
      {(vm.state.mess_id !== '') && <div className={(vm.checkTypeDelMess() === 4) ||([1,10].indexOf(rxaget(vm.state, 'mess_selected.type', '')) !== -1 && rxaget(vm.state, 'mess_selected.sender_uin', '') !== vm.userid.toString()) ? 'menu-message-box_hiden' : 'menu-message-box'}>
        {vm.checkTypeDelMess() === 3 &&
          <div>
            {vm.checkpollOption('reply') && (vm.state.isBlocked === 0) && <div className='menu-option' onClick={e => vm.chooseOption(e, 'reply')}>{translate('Reply')}</div>}
            {vm.checkpollOption('copy') && !([2, 3, 4, 12 ].indexOf(rxaget(vm.state, 'mess_selected.type', '')) !== -1) && <div className='menu-option' onClick={e => vm.chooseOption(e, 'copy')}>{translate('Copy')}</div>}
            {vm.checkpollOption('forward') && <div className='menu-option' onClick={e => vm.chooseOption(e, 'forward')}>{translate('Forward')}</div>}
            {vm.checkpollOption('resend-poll') && <div className='menu-option' onClick={e => vm.chooseOption(e, 'resend-poll')}>{translate('Send to the chat group')}</div>}
            {
              vm.checkpollOption('pin') &&
              (vm.checkPinMess() === 1 && vm.state.isBlocked === 0) &&
              <div className='menu-option' onClick={e => vm.chooseOption(e, 'pin')}>{translate('Pin')}</div>}
            {
              vm.checkpollOption('unpin') && 
              (vm.checkPinMess() === 2 && vm.state.isBlocked === 0) &&
              <div className='menu-option' onClick={e => vm.chooseOption(e, 'unpin')}>{translate('Unpin')}</div>}
          </div>}
        {vm.checkpollOption('delete_all') && vm.state.isBlocked === 0 && <div className='menu-option' onClick={e => vm.chooseOption(e, 'delete_all')}>{translate('Delete with everyone')}</div>}
        {vm.checkpollOption('delete_one') && vm.state.isBlocked === 0 && <div className='menu-option' onClick={e => vm.chooseOption(e, 'delete_one')}>{translate('Delete only me')}</div>}
      </div>}

    </div>
    { vm.state.displayScrollDownBtn === true && <div className={(vm.state.tabmoreNextprop === true) ?'scrollDownBtn_place scrollDownBtn_place_margin_right':'scrollDownBtn_place'} onClick={e => vm.scrollDownChatList(e)}>    
        <i className="scrollDownBtn"></i>
    </div>}
    
    <Suspense fallback={<div className="loading"><div className="dot-flashing"></div></div>}>
      <PinComponent
        pinedMess={vm.state.pinedMess}
        users={vm.users}
        parseMessage={vm.parseMessage}
        pin_mess_id={vm.state.pin_mess_id}
        userid={vm.userid}
        unPin={vm.unPin}
        themeValue={zget(vm.props, 'themeValue')}
        convertOmessUser={vm.convertOmessUser}
        group={vm.state.group}
        group_id={vm.state.group_id}
        modalPin={vm.state.modalPin}
        checkgallery ={vm.state.checkgallery}
        tabmoreNextprop={vm.state.tabmoreNextprop}
        token={vm.token}
        choosePoll={(pollInfo) => { vm.choosePoll(pollInfo) }}
      />
    </Suspense>

    { zget(vm.props, "rxnav.navs.searchGroup") && 
      <SearchComponent
        messages={vm.state.messages}
        users={vm.users}
        user={vm.user}
        group_id={vm.state.group_id}
        group={vm.state.group}
        refScroll_chat={vm.refScroll_chat}
        themeValue={zget(vm.props, 'themeValue')}
        onChange={key => vm.setState({ keywords: key })}
        onCancel={() => vm.props.rxnavToggle("searchGroup", {})}
        onClickToMess={messid => vm.onClickToMess(messid)}
      />
    }

    {vm.state.checkgallery && <RxImageGallery images={vm.state.galleryImages} closeShowGallery={() => vm.closeGallery()} position={vm.state.galleryPosition} />}
    {vm.state.popupGroup && <RxGroupsList closePopupGroup={() => vm.closePopupGroup()} chooseGroupForward={(groupfw) => vm.chooseGroupForward(groupfw)} />}
  </div>
</div >

export const renderComponent = (vm) => {
  return <div>
    {vm.renderBody()}
    {vm.state.infoUserScreen && <RxInfoUser closePopupInfoUser={() => vm.closePopupInfoUser()} infoUserId={vm.state.infoUserId} />}
  </div>
}